import React from 'react'
import {Box, Text} from '../../vanilla'
import {RapidInfoIcon} from '../icons'
import {useBasketStore} from '../../store/hooks/useStore'

export const getDeliveryRestrictionMessage = (
  shippingMethod: ReturnType<typeof useBasketStore>['shippingMethod']
) => {
  const isEditable = !!shippingMethod?.c_isEditableAfterOrder
  const isCancellable = !!shippingMethod?.c_isCancellableAfterOrder
  const isRapid = shippingMethod?.id === 'Rapid_Delivery'
  const orderLabel = isRapid ? 'Rapid orders' : 'this order'

  if (!isEditable && !isCancellable) {
    return `Once placed, ${orderLabel} cannot be changed or cancelled.`
  }

  if (!isEditable) {
    return `Once placed, ${orderLabel} cannot be changed.`
  }

  if (!isCancellable) {
    return `Once placed, ${orderLabel} cannot be cancelled.`
  }

  return undefined
}

const DeliveryRestrictionNotice = () => {
  const {shippingMethod, basket} = useBasketStore()

  const hasSlotBooked = basket?.c_windowStartTime

  if (!hasSlotBooked) {
    return null
  }

  const restrictionMessage = getDeliveryRestrictionMessage(shippingMethod)

  if (!restrictionMessage) {
    return null
  }

  return (
    <Box
      backgroundColor="infoSurface"
      width="full"
      display="flex"
      alignItems="flex-start"
      gap="4px"
      paddingX="8px"
      paddingY="8px"
      borderRadius="base"
      style={{boxSizing: 'border-box'}}
    >
      <RapidInfoIcon flexShrink="0" aria-hidden="true" style={{width: '17px', height: '17px'}} />
      <Text color="infoDefault" style={{fontSize: '14px'}} lineHeight="shorter">
        {restrictionMessage}
      </Text>
    </Box>
  )
}

export default DeliveryRestrictionNotice
